import { autopayHttpRequest } from '../../../core/api/axios.config';

export const state = {
  hasRequestFinished: false,
  httpRequest: autopayHttpRequest,
  mailCode: null,
  responseBody: null,
  responseStatusCode: null
};
